import type { App } from "@open-booking/server";
import type { PresignBatchUploadPayload, PresignUploadPayload } from "@open-booking/shared";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type PresignResponse = App["~Routes"]["upload"]["presign"]["post"]["response"]["200"];
type PresignBatchResponse = App["~Routes"]["upload"]["presign-batch"]["post"]["response"]["200"];

export const uploadApi = createApi({
	reducerPath: "uploadApi",
	baseQuery: edenBaseQuery(),
	endpoints: (builder) => ({
		presignUpload: builder.mutation<PresignResponse, PresignUploadPayload>({
			query:
				(payload): EdenCall<PresignResponse> =>
				(client) =>
					client.upload.presign.post(payload),
		}),
		presignBatchUpload: builder.mutation<PresignBatchResponse, PresignBatchUploadPayload>({
			query:
				(payload): EdenCall<PresignBatchResponse> =>
				(client) =>
					client.upload["presign-batch"].post(payload),
		}),
	}),
});

export const { usePresignUploadMutation, usePresignBatchUploadMutation } = uploadApi;
